// src/constants/statusConstants.js
export const APPLICATION_STATUS = {
  RESUME_SENT: 'Resume Sent',
  INTERVIEW_IN_PROGRESS: 'Interview In Progress',
  SELECTED: 'Selected',
  JOINED: 'Joined',
  REJECTED: 'Rejected'
};

export const INTERVIEW_STATUS = {
  SCHEDULED: 'Scheduled',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
  NO_SHOW: 'No Show'
};

export const JOB_STATUS = {
  OPEN: 'Open',
  CLOSED: 'Closed',
  ON_HOLD: 'On Hold'
};

export const COMPANY_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive'
};

export const STORAGE_KEYS = {
  COMPANIES: 'jsk_companies',
  JOBS: 'jsk_jobs',
  CANDIDATES: 'jsk_candidates',
  PLACEMENTS: 'jsk_placements',
  INTERVIEWS: 'jsk_interviews',
  USERS: 'jsk_users',
  CURRENT_USER: 'jsk_current_user'
};